module.exports = __webpack_public_path__ + "static/img/lxgp2.d736f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/lxgp2.jpg
// module id = 9wY7
// module chunks = 0